import { message } from "antd";
import NotFoundPage from "../components/Error/NotFoundPage";
import ReactDOM from "react-dom";
export const catchError = async (response) => {
  try {
    // Check if the response indicates success
    if (response.success) {
      message.success("Operation completed successfully!");
      return; // Exit the function after showing the success message
    }

    // Requests made with `responseType: 'blob'` (file downloads) still get
    // their error body delivered as a Blob, even when the server sent JSON.
    // Object.entries() on a Blob is always empty, so without this the error
    // handling below silently finds "no error data" and shows nothing.
    if (response?.response?.data instanceof Blob) {
      try {
        const text = await response.response.data.text();
        response = {
          ...response,
          response: { ...response.response, data: JSON.parse(text) },
        };
      } catch (blobParseError) {
        // Not JSON (e.g. an HTML debug error page) — the generic handling
        // below can't extract a message from a Blob, so show a fallback
        // instead of silently doing nothing.
        message.error("Something went wrong generating this report. Please try again or contact support.");
        return;
      }
    }

    const statusCode = response?.status || response?.response?.status;

    // Handle errors if the response does not indicate success
    const errorData =
      response?.data?.message ||
      response?.data ||
      response?.response?.data?.message ||
      response?.response?.data;
    console.log(errorData, "errorData");
    if (statusCode === 403) {
      // Render ErrorCom in case of 403 status
      message.error("Permission denied");
      return; // Exit the function after rendering ErrorCom
    } else if (statusCode === 401) {
      message.error("Session expired. Please login again.");
      return;
    }
    if (errorData) {
      if (typeof errorData === "object") {
        const errorMessages = [];

        for (const [key, value] of Object.entries(errorData)) {
          if (Array.isArray(value)) {
            value.forEach((err) => errorMessages.push(`${key}: ${err}`));
          } else {
            errorMessages.push(`${key}: ${value}`);
          }
        }

        const isEmailNotVerified =
          (Array.isArray(errorData.code) &&
            errorData.code.some(
              (c) =>
                c.toLowerCase() === "email_not_verified" ||
                c.toLowerCase() === "email not verified"
            )) ||
          errorData.code === "EMAIL_NOT_VERIFIED" ||
          errorData.code === "email_not_verified" ||
          errorData === "EMAIL_NOT_VERIFIED" ||
          errorData === "email_not_verified" ||
          response?.code === "EMAIL_NOT_VERIFIED" ||
          response?.code === "email_not_verified";

        if (isEmailNotVerified) {
          return null;
        }
        if (errorMessages.length > 0) {
          message.error(errorMessages.join("\n"));
          return; // Exit the function once the error message is shown
        }
      } else {
        message.error(errorData);
        return; // Exit the function once the error message is shown
      }
    }

    // If no error data is found, do nothing (or optionally log)
    console.warn("No error data found in response.");
  } catch (error) {
    console.log("Error:", error);
    message.error("An unexpected error occurred.");
  }
};
